<template>
  <div class="side-filters-skeleton">
    <wb-skeleton class="side-filters-skeleton__categories" />

    <div v-for="n in 7" :key="n" class="side-filters-skeleton__item">
      <wb-skeleton class="side-filters-skeleton__item--circle" />
      <wb-skeleton class="side-filters-skeleton__item--bar" />
      <wb-skeleton class="side-filters-skeleton__item--circle" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SideFiltersSkeleton',
};
</script>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.side-filters-skeleton {
  display: flex;
  flex-direction: column;
  background-color: var(--wb-grey-90);
  padding: var(--wb-spacing-s);

  &__categories {
    width: 100%;
    height: 56px;
    margin-bottom: var(--wb-spacing-s);
  }

  &__item {
    display: flex;
    flex-direction: row;
    padding: var(--wb-spacing-xs) 0;

    &--circle {
      width: 27px;
      height: 27px;
      border-radius: 50%;
      flex-grow: 0;
    }

    &--bar {
      height: 27px;
      flex-grow: 1;
      margin: 0 var(--wb-spacing-l) 0 var(--wb-spacing-s);
    }

    &:not(:last-child) {
      border-bottom: 2px solid var(--wb-grey-85);
    }
  }
}
</style>
